/**
 *
 * ModalExportReportMeasure
 *
 */

import React from "react"
// import PropTypes from 'prop-types';
import "./index.less"
import { get } from "lodash"
import { Modal, Checkbox, Radio } from "antd"

/* eslint-disable react/prefer-stateless-function */
class ModalExportReportMeasure extends React.Component {
  state = { optionsSelected: [] }

  optionsCheckbox = () => {
    const { status } = this.props
    const checkboxs = [
      { label: "Reporte de destinatarios ", value: "report_recipients" },
      {
        label: "Comentarios cualitativos (254)",
        value: "comments_qualitative",
      },
      { label: "Resultado por división", value: "result_divisions" },
      { label: "Resultado por dimensión", value: "result_dimension" },
    ]

    if (status.enps) {
      checkboxs.push({ label: "Resultado eNPS", value: "result_enps" })
    }

    return checkboxs
  }

  render() {
    const { status } = this.props

    return (
      <Modal
        visible={this.props.visible}
        width={540}
        title="Exportar reporte"
        className="modal-export-report"
        onCancel={() => {
          this.props.setStateFrom("modalExportReportMeasure", false)
          this.setState({ optionsSelected: [] })
        }}
        okButtonProps={{ disabled: !this.state.optionsSelected.length }}
        onOk={() => {
          const { optionsSelected } = this.state

          const params = {
            id: get(status, "measure.id_measure", undefined),
            data: {
              report_recipients: optionsSelected.includes("report_recipients"),
              comments_qualitative: optionsSelected.includes(
                "comments_qualitative"
              ),
              result_divisions: optionsSelected.includes("result_divisions"),
              result_enps: optionsSelected.includes("result_enps"),
              result_dimension: optionsSelected.includes("result_dimension"),
              type: "pdf",
            },
          }

          this.setState({ optionsSelected: [] })
          this.props.postExportReportWatcher(params)
          this.props.setStateFrom("modalExportReportMeasure", false)
        }}>
        <p className="modal-export-report__description">
          Selecciona las <span>variables</span> que deseas exportar:
        </p>
        <div className="modal-export-report__checkgroup">
          <Checkbox.Group
            options={this.optionsCheckbox()}
            value={this.state.optionsSelected}
            onChange={(opts) => this.setState({ optionsSelected: opts })}
          />
        </div>
        <p
          className="modal-export-report__description"
          style={{ marginTop: 14 }}>
          Selecciona el <span>formato</span> de presentación de la información:
        </p>
        <div className="modal-export-report__checkgroup">
          <Radio.Group value={2}>
            {/* <Radio value={1}>
              Excel
            </Radio> */}
            <Radio value={2}>PDF</Radio>
          </Radio.Group>
        </div>
      </Modal>
    )
  }
}

ModalExportReportMeasure.propTypes = {}

export default ModalExportReportMeasure
